import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { InfoSection } from '../common'

const pickRandomImages = (count) => {
    const urls = new Set()

    while (urls.size < count){
        const idx = Math.floor(Math.random() * 10) + 1
        urls.add("https://projects.notalepower.com/latest/img_" + idx + ".jpg")
    }

    return Array.from(urls)
}

const LatestImage = ({url, onOpen}) =>{
    return (
        <button type="button" onClick={() => onOpen(url)} className='flex-1 min-w-0'>
            <img src={url} alt="" className='w-full block bg-stone-200 dark:bg-stone-500 rounded-2xl xl:rounded-3xl p-1 xl:p-4 aspect-square object-cover'/>
        </button>
    )
}

// Full-screen preview: the dark backdrop closes it, a click on the image doesn't
const Lightbox = ({url, onClose}) =>{
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') onClose()
        }

        // Lock the page scroll while the preview is open
        const previousOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.body.style.overflow = previousOverflow
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [onClose])

    return (
        <div onClick={onClose} role="dialog" aria-modal="true" className='fixed inset-0 z-[60] flex items-center justify-center p-4 xl:p-10 bg-black/80'>
            <img src={url} alt="" onClick={(event) => event.stopPropagation()} className='max-w-full max-h-full object-contain rounded-2xl xl:rounded-3xl cursor-default'/>
        </div>
    )
}

// Picked once per visit: stays the same across re-renders and page changes
const SESSION_IMAGES = pickRandomImages(3)

export const Latest = () => {
    const urls = SESSION_IMAGES
    const [openUrl, setOpenUrl] = useState(null)
    const closePreview = () => setOpenUrl(null)

    // About stays mounted when you leave it: close the preview on page change
    const { pathname } = useLocation()
    useEffect(() => {
        setOpenUrl(null)
    }, [pathname])

    return (
        <InfoSection title={"Latest"}>
            <div className='flex gap-3 xl:gap-10 2xl:gap-16 justify-between'>
                {urls.map( (url) => <LatestImage key={url} url={url} onOpen={setOpenUrl}/> )}
            </div>
            {openUrl && <Lightbox url={openUrl} onClose={closePreview}/>}
        </InfoSection>
  )
}
